'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/get-proto/Reflect.getPrototypeOf.js
// module id = ../../../../get-proto/Reflect.getPrototypeOf.js
// module chunks = 5